import { render, staticRenderFns } from "./AegCaseHome.vue?vue&type=template&id=36f9dc96"
import script from "./AegCaseHome.vue?vue&type=script&lang=js"
export * from "./AegCaseHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports